import { render } from "./ImageViewerSettings.vue?vue&type=template&id=5d426caf&scoped=true&ts=true"
import script from "./ImageViewerSettings.vue?vue&type=script&lang=ts"
export * from "./ImageViewerSettings.vue?vue&type=script&lang=ts"

import "./ImageViewerSettings.vue?vue&type=style&index=0&id=5d426caf&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d426caf"]])

export default __exports__